const features = [
  {
    icon: 'ri-tools-line',
    title: 'Serviço Técnico Oficial',
    desc: 'Reparos e manutenções com peças originais de fábrica.',
  },
  {
    icon: 'ri-global-line',
    title: 'Cobertura Nacional',
    desc: 'Envio para todos os estados do Brasil com entrega rápida.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Garantia Oficial',
    desc: 'Equipamentos importados com garantia oficial de fábrica.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Suporte Pós-Venda',
    desc: 'Equipe técnica responde via WhatsApp em todo o Brasil.',
  },
];

export default function AboutSection() {
  return (
    <section id="sobre" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="grid grid-cols-2 gap-3">
              <div className="w-full h-64 rounded-2xl overflow-hidden">
                <img
                  alt="Estoque de máquinas de solda geomembrana cunha quente para impermeabilização no Brasil"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                  src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/A0xVvobDbRIBrVE7/muchas-rojas-con-cajas-A8543EvBNjfW0ORg.jpg"
                />
              </div>
              <div className="w-full h-64 rounded-2xl overflow-hidden mt-8">
                <img
                  alt="Soldadoras de geomembrana cunha quente disponíveis para impermeabilização profissional"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                  src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=486,fit=crop/A0xVvobDbRIBrVE7/muchas-soldadoras-rojas-mxB7kMa8jKhoPalp.jpg"
                />
              </div>
            </div>
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-green-500 text-white text-sm px-6 py-3 rounded-full whitespace-nowrap">
              +10 anos de experiência
            </div>
          </div>

          <div>
            <span className="text-green-500 text-xs uppercase tracking-widest mb-3 block">Sobre Nós</span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-5 leading-none uppercase">
              ESPECIALISTAS<br />
              <span className="text-green-500">EM GEOMEMBRANA</span>
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              A <strong className="text-gray-900 font-black">SoldaGeo</strong> tem mais de{' '}
              <strong className="text-gray-900 font-black">10 anos no mercado</strong>, sediada em Florianópolis
              (SC, Brasil) e com operação na Argentina. Somos <strong className="text-gray-900 font-black">distribuidores oficiais</strong> de{' '}
              <strong className="text-gray-900 font-black">máquinas de solda geomembrana</strong> — cunha quente,
              extrusoras e acessórios para impermeabilização profissional, em conformidade com as normas{' '}
              <strong className="text-gray-900 font-black">ABNT NBR 16199 e NBR 15352</strong>.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              Nossos equipamentos atendem projetos de{' '}
              <strong className="text-gray-900 font-black">
                mineração, piscicultura, aterros sanitários, reservatórios, barragens, canais de irrigação e impermeabilização
              </strong>{' '}
              de PEAD, PELBD e PVC em todo o Brasil — com suporte técnico pós-venda e garantia oficial de fábrica.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((f) => (
                <div key={f.title} className="flex items-start gap-3 p-4 rounded-xl bg-gray-50 border border-gray-100">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-green-100 flex-shrink-0">
                    <i className={`${f.icon} text-green-600`} />
                  </div>
                  <div>
                    <h4 className="text-gray-900 font-black text-sm mb-0.5 uppercase">{f.title}</h4>
                    <p className="text-gray-500 text-xs leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
